module.exports = __webpack_public_path__ + "static/img/strona_011.0f7448ff.jpg";